// Section 4 and 24.4: the season's phases, in order. This list is the only place the order
// lives. `decide` (phase 2) applies the logged Decision; `event-choices` applies last season's
// event answers before production (ADR-0010).
import type { Phase } from '../core/types';
import { bodiesPhase } from './bodies';
import { consumptionPhase } from './consumption';
import { crimePhase } from './crime';
import { decayPhase } from './decay';
import { decidePhase } from './decide';
import { eventChoicesPhase } from './event-choices';
import { eventsPhase } from './events';
import { lifecyclePhase } from './lifecycle';
import { migrationPhase } from './migration';
import { productionPhase } from './production';
import { rationingPhase } from './rationing';
import { reportPhase } from './report';
import { societyPhase } from './society';
import { steadyPhase } from './steady';

export const phaseOrder: readonly Phase[] = Object.freeze([
  reportPhase,
  decidePhase,
  eventChoicesPhase,
  productionPhase,
  consumptionPhase,
  rationingPhase,
  bodiesPhase,
  societyPhase,
  crimePhase,
  migrationPhase,
  lifecyclePhase,
  eventsPhase,
  decayPhase,
  steadyPhase,
]);
